import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#create_trainning_institute",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0 text-light" }, "Training Institute Entry")
  ])
], -1)
const _hoisted_3 = {
  id: "create_trainning_institute",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row d-flex" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Institute Logo", -1)
const _hoisted_10 = { id: "preview" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "row mt-3 d-flex" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Phase", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute Type", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "row mt-3 d-flex" }
const _hoisted_23 = { class: "col-md-8" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Institute Name")
], -1)
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Short Name")
], -1)
const _hoisted_27 = { class: "row mt-3 d-flex" }
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Registration Number")
], -1)
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Registration Date")
], -1)
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Registration Authority")
], -1)
const _hoisted_34 = { class: "row mt-3" }
const _hoisted_35 = { class: "col-md-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Mobile Number")
], -1)
const _hoisted_37 = { class: "col-md-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Fax")
], -1)
const _hoisted_39 = { class: "col-md-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Email", -1)
const _hoisted_41 = { class: "col-md-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Web Url")
], -1)
const _hoisted_43 = { class: "row mt-3" }
const _hoisted_44 = { class: "col-md-12" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Address")
], -1)
const _hoisted_46 = { class: "row mt-3" }
const _hoisted_47 = { class: "col-md-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Division", -1)
const _hoisted_49 = { class: "col-md-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "District", -1)
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Upazila/Thana", -1)
const _hoisted_53 = { class: "col-md-3" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Postcode", -1)
const _hoisted_55 = { class: "row mt-3" }
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Description")
], -1)
const _hoisted_58 = { class: "card mb-5 mb-xl-10" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainning_institute_details",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Add Training Institute Detail")
  ])
], -1)
const _hoisted_60 = {
  id: "trainning_institute_details",
  class: "collapse show"
}
const _hoisted_61 = { class: "collapse show" }
const _hoisted_62 = { class: "card-body border-top p-9" }
const _hoisted_63 = { class: "row mt-3" }
const _hoisted_64 = { class: "col-md-4" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Total Rooms", -1)
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Male Trainer", -1)
const _hoisted_68 = { class: "col-md-4" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Female Trainer", -1)
const _hoisted_70 = { class: "row mt-3" }
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Capacity", -1)
const _hoisted_73 = { class: "col-md-8" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Room Equipment")
], -1)
const _hoisted_75 = { class: "card mb-5 mb-xl-10" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Employee Information")
  ])
], -1)
const _hoisted_77 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_78 = { class: "collapse show" }
const _hoisted_79 = { class: "card-body border-top p-5" }
const _hoisted_80 = { class: "row d-flex" }
const _hoisted_81 = { class: "col-md-3" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Upload Employee Image", -1)
const _hoisted_83 = { id: "preview" }
const _hoisted_84 = ["src"]
const _hoisted_85 = { class: "col-md-9" }
const _hoisted_86 = { class: "row mt-3 d-flex" }
const _hoisted_87 = { class: "col-md-4" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_89 = { class: "col-md-4" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Role", -1)
const _hoisted_91 = { class: "col-md-4" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Date of Birth", -1)
const _hoisted_93 = { class: "row mt-3 d-flex" }
const _hoisted_94 = { class: "col-md-4" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Passport")
], -1)
const _hoisted_96 = { class: "col-md-4" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Driving License")
], -1)
const _hoisted_98 = { class: "col-md-4" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mobile")
], -1)
const _hoisted_100 = { class: "row mt-3 d-flex" }
const _hoisted_101 = { class: "col-md-4" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Email")
], -1)
const _hoisted_103 = { class: "col-md-4" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Gender")
], -1)
const _hoisted_105 = { class: "col-md-4" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Religion", -1)
const _hoisted_107 = { class: "row mt-3" }
const _hoisted_108 = { class: "col-md-3" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Designation")
], -1)
const _hoisted_110 = { class: "col-md-3" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "National ID")
], -1)
const _hoisted_112 = { class: "col-md-3" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father's Name")
], -1)
const _hoisted_114 = { class: "col-md-3" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mother's Name")
], -1)
const _hoisted_116 = { class: "row mt-3" }
const _hoisted_117 = { class: "col-md-8" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Address")
], -1)
const _hoisted_119 = { class: "col-md-4" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present District")
], -1)
const _hoisted_121 = { class: "row mt-3" }
const _hoisted_122 = { class: "col-md-8" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Address")
], -1)
const _hoisted_124 = { class: "col-md-4" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent District")
], -1)
const _hoisted_126 = { class: "card mb-5 mb-xl-10" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#user_account",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Add User Account")
  ])
], -1)
const _hoisted_128 = {
  id: "user_account",
  class: "collapse show"
}
const _hoisted_129 = { class: "collapse show" }
const _hoisted_130 = { class: "card-body border-top p-5" }
const _hoisted_131 = { "data-kt-stepper-element": "content" }
const _hoisted_132 = { class: "row" }
const _hoisted_133 = { class: "col-md-6" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Email", -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "" }, "Password")
    ]),
    /*#__PURE__*/_createElementVNode("span", {
      name: "password",
      class: "fv-plugins-message-container invalid-feedback"
    }, "System will generate a password and send to your email.")
  ])
], -1)
const _hoisted_136 = { class: "d-flex" }
const _hoisted_137 = ["data-kt-indicator"]
const _hoisted_138 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_139 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_140 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_141 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[47] || (_cache[47] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainning_institute.logo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainning_institute.logo) = $event)),
                      name: "file_name",
                      ref: "fileInput",
                      onChange: _ctx.updatePhoto,
                      type: "file",
                      class: "form-control"
                    }, null, 8, ["modelValue", "onChange"]),
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.url)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.url
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_ErrorMessage, {
                      name: "logo",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _hoisted_16,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Phase",
                          modelValue: _ctx.trainning_institute.tranche_id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainning_institute.tranche_id) = $event)),
                          filterable: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: trans.id,
                                label: trans.label,
                                value: trans.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(trans.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Partner",
                          modelValue: _ctx.trainning_institute.entity_id,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainning_institute.entity_id) = $event)),
                          filterable: "",
                          style: {"width":"100%"},
                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getEmployeeDesignation()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: data.id,
                                label: 
                            '[' +
                            data.entity_short_name +
                            '] - ' +
                            data.entity_name
                          ,
                                value: data.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString('[' +
                            data.entity_short_name +
                            '] - ' +
                            data.entity_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "entity_id",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _hoisted_21,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Type",
                          modelValue: _ctx.trainning_institute.training_institute_type,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.trainning_institute.training_institute_type) = $event)),
                          filterable: "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteTypes, (data) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: data.id,
                                label: data.name,
                                value: data.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(data.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "training_institute_type",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createVNode(_component_Field, {
                          name: "institute_name",
                          class: "form-control",
                          modelValue: _ctx.trainning_institute.institute_name,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.trainning_institute.institute_name) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "institute_name",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.trainning_institute.short_name,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trainning_institute.short_name) = $event)),
                          name: "short_name",
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "short_name",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.trainning_institute.registration_number,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.trainning_institute.registration_number) = $event)),
                          name: "registration_number",
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "registration_number",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createVNode(_component_el_form_item, {
                          prop: "date",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.trainning_institute.registration_date,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.trainning_institute.registration_date) = $event)),
                              "value-format": "YYYY-MM-DD",
                              format: "DD-MM-YYYY",
                              type: "date",
                              style: {"width":"100%"}
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.trainning_institute.registration_authority,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.trainning_institute.registration_authority) = $event)),
                          name: "registration_authority",
                          class: "form-control"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "registration_authority",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainning_institute.telephone,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.trainning_institute.telephone) = $event)),
                      name: "telephone",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "telephone",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainning_institute.fax,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.trainning_institute.fax) = $event)),
                      name: "fax",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainning_institute.email,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.trainning_institute.email) = $event)),
                      name: "email",
                      type: "email",
                      class: "form-control"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainning_institute.web_url,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.trainning_institute.web_url) = $event)),
                      name: "web_url",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "web_url",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainning_institute.address,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.trainning_institute.address) = $event)),
                      name: "address",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Division",
                      modelValue: _ctx.trainning_institute.division,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.trainning_institute.division) = $event)),
                      filterable: "",
                      onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getDistrict())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.divisions, (division) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: division.id,
                            label: division.division_name_eng,
                            value: division.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(division.division_name_eng), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select District",
                      modelValue: _ctx.trainning_institute.district,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.trainning_institute.district) = $event)),
                      filterable: "",
                      onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getSubDistrict())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districts, (district) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: district.id,
                            label: district.district_name_eng,
                            value: district.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Upazila/Thana",
                      modelValue: _ctx.trainning_institute.sub_district,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.trainning_institute.sub_district) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subDistricts, (sub_district) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: sub_district.id,
                            label: sub_district.upazila_name_eng,
                            value: sub_district.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(sub_district.upazila_name_eng), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.trainning_institute.postcode,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.trainning_institute.postcode) = $event)),
                      name: "postcode",
                      class: "form-control",
                      value: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "postcode",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.trainning_institute.institute_description) = $event)),
                      name: "institute_description",
                      class: "form-control form-control",
                      rows: "3"
                    }, null, 512), [
                      [_vModelText, _ctx.trainning_institute.institute_description]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_58, [
        _hoisted_59,
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.trainning_institute.number_of_training_room,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.trainning_institute.number_of_training_room) = $event)),
                    type: "text",
                    name: "number_of_training_room",
                    class: "form-control",
                    rows: "3"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "number_of_training_room",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _hoisted_67,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.trainning_institute.total_trainer_male,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.trainning_institute.total_trainer_male) = $event)),
                    name: "total_trainer_male",
                    class: "form-control"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "total_trainer_male",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.trainning_institute.total_trainer_female,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.trainning_institute.total_trainer_female) = $event)),
                    name: "total_trainer_female",
                    class: "form-control"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "total_trainer_female",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _hoisted_72,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.trainning_institute.training_capacity,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.trainning_institute.training_capacity) = $event)),
                    name: "training_capacity",
                    class: "form-control"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "training_capacity",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.trainning_institute.lab_equipment) = $event)),
                    name: "lab_equipment",
                    id: "lab_equipment",
                    rows: "10",
                    class: "form-control"
                  }, null, 512), [
                    [_vModelText, _ctx.trainning_institute.lab_equipment]
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_75, [
        _hoisted_76,
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _hoisted_82,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_img,
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.employee.employee_img) = $event)),
                    name: "employee_img",
                    ref: "employeeFileInput",
                    onChange: _ctx.employeePhoto,
                    type: "file",
                    class: "form-control"
                  }, null, 8, ["modelValue", "onChange"]),
                  _createElementVNode("div", _hoisted_83, [
                    (_ctx.employee_url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.employee_url
                        }, null, 8, _hoisted_84))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_ErrorMessage, {
                    name: "employee_image",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, [
                      _hoisted_88,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_name,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.employee.employee_name) = $event)),
                        type: "text",
                        name: "name",
                        class: "form-control",
                        rows: "3"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "name",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      _hoisted_90,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Role",
                        modelValue: _ctx.employee.role,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.employee.role) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDesignation, (designation) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: designation.id,
                              label: designation.label,
                              value: designation.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(designation.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "designation",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _hoisted_92,
                      _createVNode(_component_el_form_item, {
                        prop: "date",
                        class: "mb-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.employee.employee_dob,
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.employee.employee_dob) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            type: "date",
                            name: "dob",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _hoisted_95,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_passport,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.employee.employee_passport) = $event)),
                        name: "passport",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _hoisted_97,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_driving_license,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.employee.employee_driving_license) = $event)),
                        name: "driving_license",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_98, [
                      _hoisted_99,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_mobile,
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.employee.employee_mobile) = $event)),
                        name: "mobile",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "mobile",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("div", _hoisted_101, [
                      _hoisted_102,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.employee.employee_email,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.employee.employee_email) = $event)),
                        name: "employeeEmail",
                        class: "form-control",
                        value: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "employeeEmail",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _hoisted_104,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Gender",
                        modelValue: _ctx.employee.employee_gender,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.employee.employee_gender) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Male",
                            value: "Male"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Male")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Female",
                            value: "Female"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Female")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Other",
                            value: "Other"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Other")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "gendernew",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _hoisted_106,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Religion",
                        modelValue: _ctx.employee.employee_religion,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.employee.employee_religion) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Islam",
                            value: "Islam"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Islam")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Hindu",
                            value: "Hindu"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Hindu")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Christian",
                            value: "Christian"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Christian")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Buddhist",
                            value: "Buddhist"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Buddhist")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "religion",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  _hoisted_109,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.designation,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.employee.designation) = $event)),
                    name: "designation",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_110, [
                  _hoisted_111,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_nid,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.employee.employee_nid) = $event)),
                    name: "nid",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_112, [
                  _hoisted_113,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_father_name,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.employee.employee_father_name) = $event)),
                    name: "father_name",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_114, [
                  _hoisted_115,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_mother_name,
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.employee.employee_mother_name) = $event)),
                    name: "mother_name",
                    class: "form-control",
                    value: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("div", _hoisted_117, [
                  _hoisted_118,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_present_address,
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.employee.employee_present_address) = $event)),
                    name: "present_address",
                    class: "form-control",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_119, [
                  _hoisted_120,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Present District",
                    modelValue: _ctx.employee.employee_present_district,
                    "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.employee.employee_present_district) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: district.id,
                          label: district.district_name_eng,
                          value: district.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("div", _hoisted_122, [
                  _hoisted_123,
                  _createVNode(_component_Field, {
                    modelValue: _ctx.employee.employee_permanent_address,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.employee.employee_permanent_address) = $event)),
                    name: "permanent_address",
                    class: "form-control"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_124, [
                  _hoisted_125,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Permanent District",
                    modelValue: _ctx.employee.employee_permanent_district,
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.employee.employee_permanent_district) = $event)),
                    name: "permanent_district",
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: district.id,
                          label: district.district_name_eng,
                          value: district.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_126, [
        _hoisted_127,
        _createElementVNode("div", _hoisted_128, [
          _createElementVNode("div", _hoisted_129, [
            _createElementVNode("div", _hoisted_130, [
              _createElementVNode("div", _hoisted_131, [
                _createElementVNode("div", _hoisted_132, [
                  _createElementVNode("div", _hoisted_133, [
                    _hoisted_134,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.employee.employee_email,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.employee.employee_email) = $event)),
                      name: "employeeEmail",
                      type: "email",
                      class: "form-control",
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "employee_email",
                      class: "fv-plugins-message-container invalid-feedback"
                    })
                  ])
                ]),
                _hoisted_135
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_136, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-success",
              type: "submit",
              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.formSubmit()))
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_138, [
                    _createTextVNode(" Submit "),
                    _createElementVNode("span", _hoisted_139, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_140, [
                    _createTextVNode(" Please wait... "),
                    _hoisted_141
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_137)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}